import {
  ActivationRequiredWarning,
  SectionedHeader,
  SwitchAppButton,
} from "../../components";
import { GrayBackground } from "../../components";
import { LRSection } from "../../components/SectionedHorizontalLinedTable/GrayBackground/LRSection";
import { SubmitButton, TextInput } from "../../hook-form";
import {
  IEditDeveloperSettings,
  IHookForm,
  IViewApiKeys,
  IViewDeveloperSettings,
} from "../../interfaces-and-types";
import { LinkUrlCopyDisplay } from "../PaymentLinks/LinkUrlCopyDisplay";

export const View = ({
  goBack,
  isDirty,
  apiKeySettings,
  developerSettings,
  clearApiKeys,
  generateApiKeys,
  handleSubmit,
  control,
  errors,
  register,
}: IHookForm<IEditDeveloperSettings> & {
  apiKeySettings: IViewApiKeys | null;
  developerSettings: IViewDeveloperSettings | null;
  goBack: () => void;
  isDirty: boolean;
  clearApiKeys: () => void;
  generateApiKeys: () => void;
}) => {
  return (
    <>
      <form onSubmit={handleSubmit}>
        <ActivationRequiredWarning
          title="Please you need to activate your profile"
          subtitle="0ur guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up"
          urlTarget="/onboarding"
        />

        <div className="mb-5">
          <GrayBackground>
            <div className="flex-container col justify-content-between ">
              <div className="flex-container col row-container-account-details">
                <SectionedHeader
                  className="more-margin"
                  hasBorder={true}
                  mainHead="Live Mode Keys"
                  subHead="These keys initiate LIVE-MODE transactions."
                />

                <LRSection
                  leftText={<strong>Live Mode Secret Key</strong>}
                  rightText={
                    !apiKeySettings?.live_mode_api_secret_key ? (
                      <strong className="text-danger">
                        No API Key available. Generate new keys
                      </strong>
                    ) : (
                      <LinkUrlCopyDisplay
                        link={apiKeySettings?.live_mode_api_secret_key || ""}
                        securityRequired
                      />
                    )
                  }
                />

                <LRSection
                  leftText={<strong>Live Mode Public Key</strong>}
                  rightText={
                    <LinkUrlCopyDisplay
                      link={apiKeySettings?.live_mode_api_public_key || ""}
                    />
                  }
                />

                <LRSection
                  leftText={<strong>Live Webhook Url</strong>}
                  rightText={
                    <TextInput
                      name="live_webhook_url"
                      label=""
                      type="text"
                      containerClassName="settings-input"
                      register={register}
                      errors={errors}
                    />
                  }
                />

                <LRSection
                  leftText={<strong>Live Redirect Url</strong>}
                  rightText={
                    <TextInput
                      name="live_redirect_url"
                      label=""
                      type="text"
                      containerClassName="settings-input"
                      register={register}
                      errors={errors}
                    />
                  }
                />

                <div className="flex-container row-container-account-details-right size-100 justify-content--end align-items--end">
                  <div className="button-group">
                    <SwitchAppButton
                      size="sm"
                      kind="danger"
                      onClick={clearApiKeys}
                    >
                      Clear Live Secret API Keys
                    </SwitchAppButton>

                    <SwitchAppButton
                      size="sm"
                      kind="success"
                      onClick={generateApiKeys}
                    >
                      Re-generate Secret API Keys
                    </SwitchAppButton>
                  </div>
                </div>

                <SectionedHeader
                  className="more-margin"
                  hasBorder={true}
                  mainHead="Test Mode Keys"
                  subHead="These keys initiate TEST-MODE transactions."
                />

                <LRSection
                  leftText={<strong>Test Mode Secret Key</strong>}
                  rightText={
                    !apiKeySettings?.test_mode_api_secret_key ? (
                      <strong className="text-danger">
                        No API Key available. Generate new keys
                      </strong>
                    ) : (
                      <LinkUrlCopyDisplay
                        link={apiKeySettings.test_mode_api_secret_key}
                        securityRequired
                      />
                    )
                  }
                />

                <LRSection
                  leftText={<strong>Test Mode Public Key</strong>}
                  rightText={
                    <LinkUrlCopyDisplay
                      link={apiKeySettings?.test_mode_api_public_key || ""}
                    />
                  }
                />

                <LRSection
                  leftText={<strong>Test Webhook Url</strong>}
                  rightText={
                    <TextInput
                      name="test_webhook_url"
                      label=""
                      type="text"
                      containerClassName="settings-input"
                      register={register}
                      errors={errors}
                    />
                  }
                />

                <LRSection
                  leftText={<strong>Test Redirect Url</strong>}
                  rightText={
                    <TextInput
                      name="test_redirect_url"
                      label=""
                      type="text"
                      containerClassName="settings-input"
                      register={register}
                      errors={errors}
                    />
                  }
                />
              </div>

              <div className="flex-container row-container-account-details-right size-100 justify-content--end align-items--end">
                <div className="button-group">
                  <SwitchAppButton size="sm" kind="secondary" onClick={goBack}>
                    Cancel
                  </SwitchAppButton>

                  <SubmitButton
                    size="sm"
                    // disabled={!isDirty}
                    showChildrenWithLoadingIcon
                  >
                    Save
                  </SubmitButton>
                </div>
              </div>
            </div>
          </GrayBackground>
        </div>
      </form>
    </>
  );
};
